import { scroll } from "../base/scroll";

export function toggleScroll(dir: "enable" | "disable") {
    const lenis = scroll?.lenisInstance;
    if (!lenis) return;

    if (dir === "enable") lenis.start();
    else lenis.stop();
}

export const debounce = <T extends unknown[]>(callback: (...args: T) => void, delay: number) => {
    let timeoutTimer: ReturnType<typeof setTimeout>;

    return (...args: T) => {
        clearTimeout(timeoutTimer);

        timeoutTimer = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};
